<div class="not-found">
  <h1>404</h1>
  <p>Nie znaleziono zasobu.</p>
  <a routerLink="/">Wróć na stronę główną</a>
</div>